import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  height: 100%;
`;

const ItemLabel = styled.span`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-top: 8px;
`;

const OtherSection = styled.div`
  margin-top: 18px;
`;

const OtherLabel = styled.div`
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 18px;
`;

const PRIMARY_ITEMS = [
  { id: 'flights', label: 'Flights' },
  { id: 'hotels', label: 'Hotels' },
];

export default function ScheduleModule() {
  return (
    <Container>
      <List>
        {PRIMARY_ITEMS.map((item) => (
          <ItemLabel key={item.id}>{item.label}</ItemLabel>
        ))}
      </List>

      <OtherSection>
        <OtherLabel>Other things that dizee would track,</OtherLabel>
      </OtherSection>
    </Container>
  );
}

